<template>
  <div
    id="coursesOutline"
    class="courses-outline"
  >
    <div class="syllabus-information">
      <div>
        <h2 class="syllabus-ouline">
          {{ $t('coursesDetail.syllabus') }}
        </h2>
        <div v-if="planDescription" class="courses-outlin-desc">
          {{ planDescription }}
        </div>
        <dl
          v-for="(item,index) in courseScheduleList"
          :key="item.num"
          class="outline-item"
          :class="!item.isStarted?'isStart':''"
        >
          <dt>{{ getSyllabusNum(index+1) }}</dt>
          <dd>
            <p class="lecture_time">
              {{ item.lecture_time }}
            </p>
            <h2
              :style="{fontWeight: 400}"
              class="text-overflow-ellipsis lecture_name"
              :title="item.lecture_name"
            >
              {{ item.lecture_name }}
            </h2>
          </dd>
          <span v-if="!item.isStarted" class="started-tag">{{ $t('coursesDetail.startedTag') }}</span>
        </dl>
      </div>
    </div>
    <div v-if="courseSchedule.length>5" class="fold-btn" :class="fold?'fold-status':'unfold-status'" @click="toggleFold">
      {{ !fold?$t('coursesDetail.courseScheduleBtn[0]'): $t('coursesDetail.courseScheduleBtn[1]',[courseSchedule.length]) }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    courseSchedule: {
      default: () => [],
      type: Array,
    },
    detailData: {
      default: () => ({}),
      type: Object,
    },
  },
  data() {
    return {
      activeIndex: 0,
      fold: true,
      isKeepTwoDecimal: this.$t('common.isKeepTwoDecimal'),
    }
  },
  computed: {
    planDescription() {
      const { staticData } = JSON.parse(this.detailData.operation || '{}')
      return staticData && staticData.planDescription
    },
    locale() {
      return this.$store.state.locale
    },
    courseScheduleList() {
      if (this.courseSchedule.length > 5 && this.fold) {
        return this.courseSchedule.slice(0, 5)
      }
      return this.courseSchedule
    },
    showSessionText() {
      if (this.detailData.spec.lessonCount - this.detailData.spec.leftLesson === 1) {
        return this.locale === 'us' ? '1 lesson started' : '1 session started'
      } if (this.detailData.spec.lessonCount === 1) {
        return this.locale === 'us' ? '1 lesson' : '1 session'
      } if (this.detailData.spec.lessonCount === this.detailData.spec.leftLesson) {
        return this.locale === 'us' ? `${this.detailData.spec.lessonCount} lessons` : `${this.detailData.spec.lessonCount} sessions`
      }
      return this.locale === 'us' ? `${this.detailData.spec.lessonCount - this.detailData.spec.leftLesson} lessons started` : `${this.detailData.spec.lessonCount - this.detailData.spec.leftLesson} sessions started`
    },
  },
  methods: {
    toggleFold() {
      this.fold = !this.fold
    },
    getSyllabusNum(index) {
      return index >= 10 ? index : `0${index}`
    },
  },
}
</script>
<style lang="scss" >
.courses-outline {
  display: flex;
  flex-direction: column;
  align-items: center;

  .courses-outlin-desc {
    max-width: 780px;
    font-size: 18px;
    font-weight: 500;
    color: var(--txt-color-lv1);
    word-wrap: break-word;
    margin-bottom: 20px;
    line-height: 24px;
  }

  .top-price-status {
    display: flex;
    align-items: flex-end;
  }

  #information {
    padding-bottom: 9px;
  }

  .price {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    color: #fd7924;

    .original-price {
      position: relative;
      font-size: 16px;
      font-weight: 300;
      margin-right: 14px;
      display: inline-block;
      color: var(--txt-color-lv2);

      .line-through {
        position: absolute;
        width: 100%;
        height: 1px;
        background: var(--txt-color-lv2);
        top: 30px;
        left: 0;
      }
    }

    .present-price {
      font-size: 24px;
      font-weight: bold;
      margin-right: 14px;
    }
  }

  .syllabus-ouline {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    font-size: 32px;
    color: var(--txt-color-lv1);
    font-weight: 600;
    padding-top: 40px;
    margin-bottom: 12px;

    .sell_num {
      display: block;
      background: rgba(255, 255, 255, 1);
      padding: 6px 12px;
      border-radius: 14px;
      font-size: 14px;
      font-weight: 600;
      color: var(--txt-color-lv2);
      line-height: 16px;
    }
  }

  .syllabus-information {
    width: 780px;
    background: #f4f6fa;

    .tabs {
      position: fixed;
      top: 0;
      width: 100%;
      height: 60px;
      background: #fff;
      line-height: 60px;
      display: flex;
      z-index: 99;

      a {
        position: relative;
        display: inline-block;
        width: 203px;
        cursor: pointer;
        text-align: center;
      }

      .is-active {
        background: #fff;
      }

      .is-active::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 3px;
        background: var(--txt-color-link);
      }
    }
  }

  .title-ouline {
    font-size: 20px;
    line-height: 23px;
    color: var(--txt-color-lv1);
    padding-bottom: 40px;
    font-weight: bold;
  }

  .outline-item {
    position: relative;
    display: flex;
    align-items: center;
    padding: 15px 40px;
    margin-bottom: 10px;
    background: #fff;
    border-radius: 10px;

    dt {
      position: absolute;
      left: -5px;
      top: 50%;
      transform: translateY(-50%);
      width: 26px;
      height: 38px;
      line-height: 38px;
      font-weight: bold;
      text-align: center;
      background: url("~assets/images/courses/syllabus-num-bg.png");
      background-size: cover;
      font-size: 16px;
      color: #fff;
    }

    dd {
      font-weight: 500;

      h2 {
        font-weight: 500 !important;
        font-size: 18px;
        line-height: 18px;
        color: var(--txt-color-lv1);
        width: 640px;
      }

      p {
        margin-bottom: 4px;
        font-size: 14px;
        line-height: 16px;
        color: var(--txt-color-lv2);
      }
    }

    .outline-is-start {
      display: block;
      position: absolute;
      right: 20px;
      top: 20px;
      width: 80px;
      height: 28px;
      font-size: 14px;
      font-weight: 500;
      color: rgba(162, 170, 184, 1);
    }

    &.isStart {
      dd {
        opacity: 0.6;
      }
    }

    .started-tag {
      position: absolute;
      right: 20px;
      top: 20px;
      height: 28px;
      width: auto;
      padding: 0 10px;
      text-align: center;
      line-height: 28px;
      font-weight: 500;
      color: var(--txt-color-lv2);
      background: rgba(244, 246, 250, 1);
      border-radius: 14px;
    }
  }

  .remain-times {
    display: flex;
    margin-right: 16px;

    .remain-time {
      display: block;
      width: 28px;
      height: 28px;
      text-align: center;
      line-height: 28px;
      color: #fff;
      font-size: 16px;
      background: var(--txt-color-link);
      border-radius: 4px;
    }

    .remain-dot {
      line-height: 28px;
      color: var(--txt-color-lv2);
      margin: auto 4px;
    }
  }

  .fold-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    background: #fff;
    color: var(--txt-color-link);
    font-size: 14px;
    cursor: pointer;
    border-radius: 9px;
    font-weight: 500;

    &.fold-status {
      width: 172px;
    }

    &.unfold-status {
      width: 139px;
    }

    &.fold-status::before {
      content: '';
      width: 17px;
      height: 17px;
      background-image: url("~assets/images/courses/unfold.png");
      background-size: cover;
    }

    &.unfold-status::before {
      content: '';
      width: 17px;
      height: 17px;
      background-image: url("~assets/images/courses/fold.png");
      background-size: cover;
    }
  }
}
</style>
